import { jsx as _jsx } from "react/jsx-runtime";
import CellTowerIcon from '@mui/icons-material/CellTower';
import ChargingStationIcon from '@mui/icons-material/ChargingStation';
import PersonIcon from '@mui/icons-material/Person';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import { Badge, Stack, Tooltip } from '@mui/material';
import { useContext } from 'react';
import { Provider } from 'react-redux';
import { AppMainViewContext } from '../../ContextProviders/AppContextProvider';
import { useSystemSelector } from '../../redux/reducers/hooks';
import { systemStore } from '../../redux/stores/SystemStore';
const { NODE_ENV } = process.env;
const apiNames = {
    NetworkApi: 'Network Data',
    DeviceControlApi: 'Device Control',
    SystemManagementApi: 'System Management',
    ConsumerApi: 'Consumer Data',
};
const apiNameIcons = {
    NetworkApi: CellTowerIcon,
    DeviceControlApi: ChargingStationIcon,
    SystemManagementApi: SupportAgentIcon,
    ConsumerApi: PersonIcon,
};
export const TransactionDash = (props) => {
    return (_jsx(Provider, { store: systemStore, children: _jsx(TransactionDashInternal, { ...props }) }));
};
const TransactionDashInternal = ({ isAuthenticated }) => {
    const inFlightTransactions = useSystemSelector((state) => state.inFlightTransactions);
    const [{ isSmallView }] = useContext(AppMainViewContext);
    const openTransactions = Object.entries(inFlightTransactions).reduce((a, [id, { apiRef, path }]) => {
        if (!a[apiRef]) {
            a[apiRef] = 0;
        }
        a[apiRef]++;
        return a;
    }, {});
    return NODE_ENV === 'development' && !isSmallView && isAuthenticated ? (_jsx(Stack, { direction: 'row', spacing: 0.75, children: Object.entries(apiNameIcons).map(([apiName, Icon], i) => {
            const count = openTransactions[apiName];
            return (_jsx(Tooltip, { title: apiNames[apiName], placement: "bottom", arrow: true, children: _jsx(Badge, { color: "secondary", badgeContent: count, overlap: "circular", anchorOrigin: { vertical: 'bottom', horizontal: 'right' }, slotProps: { badge: { sx: { bottom: '30%' } } }, children: _jsx(Icon, { color: 0 < count ? 'secondary' : 'inherit', sx: { opacity: 0.8, marginBlock: 1 } }) }) }, i));
        }) })) : null;
};
